import React from 'react'
import { Consumer } from '../../context';
import { Link } from 'react-router-dom';
import ImageCardLight from '../Cards/ImageCardLight';
import {v4 as uuid} from 'uuid'

function Inktober2020Section() {
    return (
        <Consumer>
            {(value) => {
                
                const {inktober2020} = value;
                
                return (
                    <div>
                        <div className="container-fluid darkSection">
                            <div className="container">
                                <div className="display-5 text-center pt-5 pb-3">
                                    I n k t o b e r - 2 0 2 0 
                                </div>
                                <div className="row pb-3 px-5 font-monospace">
                                    {inktober2020.slice(0,3).map((ill) => (
                                        <div key={uuid()} className="col-12 col-md-6 col-lg-4 py-lg-5 py-3">
                                            <ImageCardLight
                                                //section={inktober2020}
                                                image={ill} />
                                        </div>
                                    ))}
                                </div>
                                <div className="pb-3">
                                    <Link to="/gallery/inktober2020" className="sectionlink">
                                        <h5 className="text-end pe-5 font-monospace">
                                            View all <i className="fas fa-arrow-right align-middle"></i>
                                        </h5>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }}
        </Consumer>
    )
}

export default Inktober2020Section;